import { mapGetters } from 'vuex';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';

export default {
    name: 'homeNearbyViewed',
    components: {
        mvtNearby,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'viewedListings']),
        ...mapGetters('home', ['home']),
    },
};
